import { User } from '@/models/User';
import { ActionContext } from 'vuex';
import { State } from '@/store/state';
import store from '@/store';
import { computePosition, flip, offset, shift } from '@floating-ui/dom';
import { VueRenderer } from '@tiptap/vue-2';
import MentionDetailsView from '@/components/tiptap/extensions/Mention/MentionDetailsView.vue';
import { dispatchLoadArticleComments } from '@/store/dispatchers/articleCommentsDispatchers';
import {
  commitSetCommentsSidebarIsVisible,
  commitSetCommentsSidebarScrollToCommentId,
} from '@/store/commits/commentsSidebarCommits';

export const commentsSidebarActions = {
  async commentsSidebarCheckAutoShowComment() {
    if (document.location.href.includes('?showComment=')) {
      const parts = document.location.href.split('?showComment=');
      const commentId = parts[1];

      if (commentId) {
        // show sidebar and scroll to specific comment
        document.location.href = parts[0];

        // show sidebar with a timeout to avoid issue wuth autoclosing on route change
        window.setTimeout(async () => {
          await dispatchLoadArticleComments();
          commitSetCommentsSidebarScrollToCommentId(commentId);
          commitSetCommentsSidebarIsVisible(true);
        }, 300);
      }
    }
  },
  async commentsSidebarShowMentionDetails(_: ActionContext<State, any>, element: HTMLElement) {
    const userId = element.dataset['id'];
    const user = userId ? store.state.companyUsers.find((user: User) => user.id === userId) : undefined;
    if (!user) return;

    const component = new VueRenderer(MentionDetailsView, {
      parent: null,
      propsData: { user },
    });

    const popup = document.createElement('div');
    popup.style.position = 'absolute';
    popup.style.zIndex = '9999';
    popup.appendChild(component.element);
    document.body.appendChild(popup);

    const updatePosition = () => {
      const virtualEl = {
        getBoundingClientRect: () => element.getBoundingClientRect(),
      };

      computePosition(virtualEl, popup, {
        placement: 'bottom-start',
        middleware: [offset(8), flip(), shift({ padding: 8 })],
      }).then(({ x, y }) => {
        Object.assign(popup.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    };

    updatePosition();

    const onClickOutside = (event: MouseEvent) => {
      if (!popup.contains(event.target as Node) && !element.contains(event.target as Node)) {
        destroy();
      }
    };

    const destroy = () => {
      document.removeEventListener('mousedown', onClickOutside);
      popup.remove();
      component.destroy();
    };

    document.addEventListener('mousedown', onClickOutside);
  },
};
